import { lazy } from "react"

export const NotificaionsPage = lazy(() => import("./NotificationsPage"))